var _style, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeldDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 479",
    style: {
      enableBackground: "new 0 0 1366 479"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Path_1_);}\n\t.st2{fill:url(#Path_2_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Combined-Shape_1_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Combined-Shape_2_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M786.5,316.1c0,6.8-2.2,9.2-9.2,9.2h-30.7c-6.8,0-9.2-2.2-9.2-8.9l0.5-74l-47.9,52 c-4.6,5.1-7.5,5.1-12.1,0L630,242.7l0.2,73.7c0,6.8-2.4,8.9-9.2,8.9h-29.7c-6.8,0-9.2-2.4-9.2-9.2V196.9c0-6.8,1.7-10.6,6.8-15.5 l17.2-16.2c5.1-4.8,8.5-4.6,13.3,0.5l64.8,66.5l65-66.5c5.1-5.1,8.2-5.1,13.1-0.5l17.6,16.7c4.8,4.6,6.5,8.7,6.5,15.5v118.7 L786.5,316.1L786.5,316.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st0",
    d: "M835.6,179.5c0-6.8,2.2-9.2,9.2-9.2h115.8c6.8,0,9.2,2.2,9.2,9.2v22c0,6.8-2.2,9.2-8.9,9.2 l-77.8-0.5v16l68.4-0.2c6.8,0,8.9,2.4,8.9,9.2v24.4c0,6.8-2.2,9.2-8.9,9.2l-68.4-0.5v16.9l78.8-0.2c6.8,0,8.9,2.4,8.9,9.2V316 c0,6.8-2.4,9.2-9.2,9.2H844.8c-6.8,0-9.2-2.4-9.2-9.2V179.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st0",
    d: "M1140.5,277.4c6.8,0,8.9,2.2,8.9,9.2v29.2c0,6.8-2.2,9.2-9.2,9.2h-113.8c-6.8,0-9.2-2.4-9.2-9.2 V179.3c0-6.8,2.4-9.2,9.2-9.2h31.7c6.8,0,9.2,2.2,9.2,8.9l-0.2,98.6L1140.5,277.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1186.664866, 169.336561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st0",
    d: "M50.8,109.5h61.6L124,97.7V59.5l-12.1-12.3H50.8V109.5z M10.2,155.7c-6.8,0-9.2-2.4-9.2-9.2V10.2 C1,3.4,3.4,1,10.2,1h117.5c6.8,0,10.6,1.5,15.5,6.3L171.6,36c4.8,4.8,6.3,8.7,6.3,15.5v53.9c0,6.8-1.7,10.9-6.5,15.7l-28,28 c-4.8,4.8-8.9,6.5-15.7,6.5L10.2,155.7L10.2,155.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_3_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4108.2251,
    y1: 11.3712,
    x2: -4107.3931,
    y2: 10.88,
    gradientTransform: "matrix(473.706 0 0 473.707 1946134 -5031.1807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C93554"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA374A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    className: "st1",
    d: "M239.4,2.6C108.5,2.6,2.5,108.6,2.5,239.5c0,130.8,106,236.9,236.9,236.9s236.9-106,236.9-236.9 C476.2,108.6,370.2,2.6,239.4,2.6L239.4,2.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -4107.4531,
    y1: 10.8179,
    x2: -4108.2837,
    y2: 11.3171,
    gradientTransform: "matrix(476.706 0 0 476.707 1958483.5 -5035.6807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA3740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA3743"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    className: "st2",
    d: "M239.4,1.1C107.7,1.1,1,107.8,1,239.5c0,131.6,106.7,238.3,238.4,238.3s238.3-106.7,238.3-238.3 C477.7,107.8,371,1.1,239.4,1.1z M239.4,4.1c130,0,235.4,105.4,235.4,235.4S369.4,474.9,239.4,474.9S4,369.4,4,239.5 C4,109.5,109.4,4.1,239.4,4.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_3_"
  }, /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2_",
    className: "st0",
    d: "M343.2,213.4l-26.4-78.3c-2.8-8.1-10.4-13.6-19-13.7h-0.1c-8.6,0-16.2,5.4-19,13.6 l-39.4,114.5L199.9,135c-2.8-8.1-10.4-13.6-19-13.6h-0.1c-8.6,0-16.2,5.5-19,13.7l-26.4,78.3H89c-11.1,0-20.1,9-20.1,20.1 s9,20.1,20.1,20.1h32.9l-18.4,54.6c-3.5,10.5,2.1,21.9,12.6,25.5c2.1,0.7,4.3,1.1,6.4,1.1c8.4,0,16.2-5.3,19-13.7L181.1,204 l39.2,114c2.8,8.1,10.4,13.6,19,13.6s16.2-5.4,19-13.6l39.2-114l39.6,117.2c3.5,10.5,14.9,16.2,25.5,12.6 c10.5-3.5,16.2-14.9,12.6-25.5l-18.4-54.6h32.9c11.1,0,20.1-9,20.1-20.1s-9-20.1-20.1-20.1L343.2,213.4L343.2,213.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4031.5862,
    y1: 33.7188,
    x2: -4031.1433,
    y2: 33.2559,
    gradientTransform: "matrix(48.3521 0 0 142.3942 195083.1406 -4559.8496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D33651",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    style: {
      stopColor: "#D43650",
      stopOpacity: 0.3265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    style: {
      stopColor: "#D6364F"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_5_",
    className: "st3",
    d: "M161.4,136.8c0,0,0,0.2-0.3,1.6c-0.2,1.1-0.3,2.2-0.3,3.4c0,2,0.2,3.8,0.7,5.6 l20.4,58.8l-24.2,73l-24.1-65.6l25.3-73.8l0.6,1.8L161.4,136.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -4031.4512,
    y1: 33.717,
    x2: -4031.0203,
    y2: 33.2673,
    gradientTransform: "matrix(48.2768 0 0 142.3942 194889.7656 -4559.8496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D33651",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    style: {
      stopColor: "#D43650",
      stopOpacity: 0.3265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    style: {
      stopColor: "#D6364F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_4_",
    className: "st4",
    d: "M278,136.8c0,0,0,0.2-0.3,1.6c-0.2,1.1-0.3,2.2-0.3,3.4c0,2.1,0.3,4.1,0.9,6 l20.2,58.7l-24.2,72.7l-24.1-65.6l25.3-73.8l0.6,1.8L278,136.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeldDark);
export default __webpack_public_path__ + "static/media/meldDark.91c233471b6eabb38711b166b5cc498c.svg";
export { ForwardRef as ReactComponent };